import { useEffect } from 'react'
import { AnalyticsService } from '@/services/analytics.js'
import { MemberDialog } from '@/components/members/MemberDialog.jsx'
import { useNavigate, useParams } from 'react-router-dom'
import { useSpaceMemberForm } from '@/hooks/useSpaceMemberForm.jsx'
import { useRoleGuard } from '@/hooks/useRoleGuard.jsx'
import { UserRoles } from '@/consts/index.js'
import { useCurrentSpace } from '@/hooks/useCurrentSpace.jsx'


export const GlobalInviteUserDialog = ({ open, closeDialog }) => {

    const { accountId, spaceId } = useParams()
    const { space } = useCurrentSpace()
    const { submitMemberForm } = useSpaceMemberForm(spaceId)
    const isAccountAdmin = useRoleGuard(UserRoles.ADMIN, 'account')
    const navigate = useNavigate()

    useEffect(() => {
        if (open) {
            AnalyticsService.track('new-user-invite-global-dialog-open')
        }
    }, [open])


    const navigateToAccountMembersSettingsPage = () => {
        closeDialog()
        navigate(`/account/${accountId}/space/${spaceId}/dashboard/settings/account/members`)
    }


    return (
        <MemberDialog
            open={open}
            onOpenChange={closeDialog}
            onSubmit={(memberData) => submitMemberForm(memberData, undefined, closeDialog)}
            title="Invite a member to your space"
            description="Enter the email address of the user you'd like to invite"
            navigateToAccountMembersSettingsPage={isAccountAdmin ? navigateToAccountMembersSettingsPage : null}
            spaceName={space?.name}
        />
    )
}